// Creator onboarding: promo codes whose owners (adult content creators, not kids)
// should still walk through a SHORT onboarding after redeeming, instead of being
// dropped straight on /home. The short path lives in Onboarding.jsx (creatorMode).
// Flag is sessionStorage so it dies with the tab and can never leak to real users.

const CREATOR_ONBOARDING_CODES = ['MIKE', 'LUKAS'];

const FLAG_KEY = 'ttt_creator_onboarding';

export const isCreatorOnboardingCode = (code) =>
  CREATOR_ONBOARDING_CODES.includes(String(code || '').trim().toUpperCase());

export const setCreatorOnboardingFlag = () => {
  try {
    sessionStorage.setItem(FLAG_KEY, '1');
  } catch {
    // sessionStorage unavailable (private mode quirks): creator just lands on /home
  }
};

export const isCreatorOnboardingActive = () => {
  try {
    return sessionStorage.getItem(FLAG_KEY) === '1';
  } catch {
    return false;
  }
};

export const clearCreatorOnboardingFlag = () => {
  try {
    sessionStorage.removeItem(FLAG_KEY);
  } catch {
    // noop
  }
};
